<template>
    <v-card class="v-avatar pa-0 d-flex align-center justify-center" :color="color" :width="size" :height="size" rounded="circle" elevation="0">
      <v-img v-if="imageId" :src="imgSrc" width="100%" height="100%" @error="loading = false">
        <template v-slot:placeholder>
          <div class="full-width full-height d-flex align-center justify-center">
            <v-progress-circular v-if="loading" indeterminate color="primary" :size="30" />
            <hub-icon v-else-if="iconType !== 'buildings'" color="primary" :size="iconSize" style="transition: none;">{{iconType}}</hub-icon>
            <v-icon v-else color="primary" :size="iconSize" style="transition: none;">fa fa-fw fa-{{iconType}}</v-icon>
          </div>
        </template>
      </v-img>
      <hub-icon v-else-if="iconType !== 'buildings'" color="primary" :size="iconSize" style="transition: none;">{{iconType}}</hub-icon>
      <v-icon v-else color="primary" :size="iconSize" style="transition: none;">fa fa-fw fa-{{iconType}}</v-icon>
    </v-card>
</template>

<script>
  import Asset from "@/modules/hub-module/services/asset"

  import HubIcon from "@/components/HubIcon";

  export default {
    props: {
      imageId: String,
      type: String,
      size: {
        type: Number,
        default() {
          return 120;
        }
      },
      imageSize: Number,
      imageFrom: String,
      color: {
        type: String,
        default() {
          return "primary lighten-4";
        }
      },
      date: Number,
      direct: Boolean
    },
    components: {
      HubIcon
    },
    computed: {
      iconType() {
        switch (this.type) {
          case "organisation":
            return "buildings";
          
          case "group":
            return "groups";

          default:
            return "user";
        }
      },
      iconSize() {
        return Math.round(this.size * 0.55);
      },
      // imgSrc() {
      //   let src = this.$hub.avatarURL(this.imageId, this.direct ? null : this.type, {date: this.date || 0, width: (this.imageSize || this.size) * 2});
      //   console.log("src",src)
      //   return src
      // }
      imageSettings() {
        return `${this.imageId || ``}${this.type || ``}${this.size || ``}${this.imageSize || ``}${this.imageFrom || ``}${this.date || ``}`
      }
    },
    data: () => ({
      loading: false,
      imgSrc: ""
    }),
    watch: {
      imageSettings(val, oldVal) {
        if(val && oldVal !== val) this.collectImageUrl();
      }
    },
    methods: {
      async collectImageUrl() {
        if(!this.imageId) {
          this.imgSrc = "";
        } else {
          console.log("avatar init",this.imageId, this.type);
          let imageParams = {date: this.date || 0, width: (this.imageSize || this.size) * 2};
          switch (this.type) {
            case "organisation":
              if(this.imageFrom) imageParams.fromOrganisation = this.imageFrom;
              break;

            case "group":
              if(this.imageFrom) imageParams.fromGroup = this.imageFrom;
              break;

            default:
              if(this.imageFrom) imageParams.fromUser = this.imageFrom;
              break;
          }

          this.imgSrc = await Asset.getUrl(this.imageId, {params: imageParams}).then(({data}) => data.url);
        }
      }
    },
    mounted () {
      this.collectImageUrl();
    }
  }
</script>
